export default __webpack_public_path__ + "static/media/Y12.995195ec.jpg";